import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import DefaultLayout from "../../components/layout/DefaultLayout";
import EnrolmentInfo from "../../components/enrolment-info/EnrolmentInfo";
import PaymentInfo from "../../components/payment-info/PaymentInfo";
import {
  addNoteFromEnrolment,
  fetchEnrolsAction,
} from "../enrolment/enrolmentAction";
import "./enrolmentDetails.css";

const EnrolmentDetails = () => {
  const navigate = useNavigate(); // React Router v6
  const dispatch = useDispatch();
  const { _id } = useParams();

  const noteRef = useRef();
  const sendEmailRef = useRef();
  const subjectRef = useRef();
  const sendSMSRef = useRef();

  const { enrollments } = useSelector((state) => state.enroll);
  const { user } = useSelector((state) => state.user);

  const enrolment = enrollments.find((enrollment) => enrollment._id === _id);

  const [showSubject, setShowSubject] = useState(false);

  const params = new URLSearchParams();
  params.set("branch", user?.branch);
  const par = params.toString();

  useEffect(() => {
    if (_id) dispatch(fetchEnrolsAction(par));
  }, [_id, dispatch, par]);

  const handleOnSubmit = () => {
    if (!noteRef.current?.value) {
      toast.warn("Please add some message");
      return;
    }

    dispatch(
      addNoteFromEnrolment({
        _id,
        message: noteRef.current.value,
        sendEmailFromNote: sendEmailRef.current?.checked,
        sendSMSFromNote: sendSMSRef.current?.checked,
        subject: subjectRef.current?.value,
        email: enrolment?.email,
        fName: enrolment?.fName,
        phone: enrolment?.mobile,
        params: par,
      })
    );

    noteRef.current.value = "";
    setShowSubject(false);
  };

  if (!enrolment) return <DefaultLayout>No enrolment found.</DefaultLayout>;

  return (
    <DefaultLayout>
      <Row className="mb-3">
        <Col>
          <Button
            variant="outline-secondary"
            onClick={() => navigate("/enrol")}
          >
            &lt; Back
          </Button>
        </Col>
      </Row>

      <EnrolmentInfo />
      <PaymentInfo />

      <Container className="mt-5 courseInfo">
        <Row className="py-2">
          <Col>
            <h5>Conversation History</h5>
            <hr />
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="message-history">
              {enrolment?.note?.length ? (
                enrolment.note.map(
                  (msg, i) =>
                    msg.message && (
                      <div className="message-history-list" key={i}>
                        <div className="mb-1">
                          {msg.addedBy} -{" "}
                          <small>
                            {new Date(msg.addedAt).toLocaleString([], {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                              hour12: true,
                              hour: "numeric",
                              minute: "numeric",
                            })}
                          </small>
                        </div>
                        <div className="lead-message">
                          {msg.message}
                          {msg.tag && (
                            <span className="lead-message-tag">
                              <i className="fa-solid fa-circle-check text-success"></i>
                              <i>{msg.tag}</i>
                            </span>
                          )}
                        </div>
                      </div>
                    )
                )
              ) : (
                <p>No messages yet.</p>
              )}
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="reply-msg mt-5 mb-2">
              <Form.Group as={Col}>
                <Form.Label style={{ color: "grey" }}>Reply</Form.Label>
                <Form.Control
                  ref={noteRef}
                  as="textarea"
                  rows="3"
                  className="my-3"
                  placeholder="'Dear clientName' in the header and 'Dented Code info' in footer is automatically added. Please only add the main body text."
                />

                {showSubject && (
                  <div className="d-flex align-items-center gap-2 mb-2">
                    Subject:
                    <Form.Control
                      type="text"
                      placeholder="Enter subject for email..."
                      ref={subjectRef}
                    />
                  </div>
                )}

                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <Form.Check
                      ref={sendEmailRef}
                      onChange={(e) => setShowSubject(e.target.checked)}
                    />
                    <span>Send as email</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 mb-3 text-danger">
                    <Form.Check ref={sendSMSRef} />
                    <span>Send as SMS</span>
                  </div>
                </div>

                <Button onClick={handleOnSubmit} variant="primary">
                  Reply
                </Button>
              </Form.Group>
            </div>
          </Col>
        </Row>
      </Container>
    </DefaultLayout>
  );
};

export default EnrolmentDetails;
